import { set } from 'date-fns';
import { UserCredential } from 'firebase/auth'; // adjust if you're using a custom type
import { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';

import { zeosDialog } from '../components/Shared/confirm-dialog/ConfirmDialog';
import { AuthContext } from '../context/AuthContext';
import { resetOnboardingState } from '../redux-store/OnboardingSlice';
import { BAD_LOGIN } from '../services/auth/AuthHelpers';
import { COMPLETED_FORM_STORAGE_KEY } from '../services/forms/FormHelpers';
import { useSessionStorage } from './useSessionStorage';

//TODO: SEEMS LIKE THESE SHOULD BE THEIR OWN ARGUMENTS IN THE SIGNATURE
export interface ISignInOptions {
  onSuccess?: (user: UserCredential) => Promise<void> | void;
  onFailure?: (error: any) => Promise<void> | void;
  email: string;
  password: string;
}

export const useSignIn = () => {
  const { signInAsync, signOutAsync } = useContext(AuthContext);
  const dispatch = useDispatch();
  const [completedForms, setCompletedForms, clearCompleteForms] =
    useSessionStorage(COMPLETED_FORM_STORAGE_KEY, [] as any);
  const [loading, setLoading] = useState(false);

  const signIn = async (props: ISignInOptions) => {
    const successHandler: (user: UserCredential) => Promise<void> = async (
      user
    ) => {
      if (props.onSuccess) {
        await props.onSuccess(user);
      }
    };

    const failureHandler: (error: any) => Promise<void> = async (error) => {
      if (props.onFailure) {
        await zeosDialog(BAD_LOGIN);
        await props.onFailure(error);
      }
    };

    try {
      setLoading(true);
      await signInAsync(
        props.email,
        props.password,
        successHandler,
        failureHandler
      );
    } catch (error) {
      zeosDialog(BAD_LOGIN);
      // setWait(false);
    } finally {
      setLoading(false);
    }
  };

  const signOut = async (onSuccess?: () => void) => {
    try {
      setLoading(true);
      await signOutAsync(() => {
        // Clear session/local storage and redux on sign-out
        try {
          clearCompleteForms();
        } catch {}
        try {
          localStorage.removeItem("onboarding-location");
          localStorage.removeItem("uapi_referral_code");
        } catch {}
        try {
          dispatch(resetOnboardingState());
        } catch {}
        onSuccess && onSuccess();
      });
    } finally {
      setLoading(false);
    }
  };

  return { signIn, signOut, loading };
};
